<template>
  <div
    data-test="performanceScore"
    :class="{
      'is-blurred': loading,
      'is-invisible': loading && !supportsBlur
    }"
  >
    <div
      id="performanceScore"
    >
      <vue-circle
        ref="circleChart"
        :progress="data"
        :size="220"
        :reverse="false"
        line-cap="round"
        :fill="fill"
        empty-fill="rgba(0, 0, 0, .1)"
        :animation-start-value="0.0"
        :start-angle="0"
        insert-mode="append"
        :thickness="20"
        :show-percent="false"
      >
        <h2><strong data-test="score">{{ data }}/100</strong></h2>
      </vue-circle>
    </div>
  </div>
</template>

<script>
import VueCircle from 'vue2-circle-progress/src/index.vue'

export default {
  name: 'BasePerformanceScore',

  components: {
    VueCircle
  },

  props: {
    data: {
      type: [String, Number],
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    supportsBlur: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      fill: { color: ['rgb( 228,0,43 )'] }
    }
  },

  updated () {
    this.$refs.circleChart &&
      this.$refs.circleChart.updateProgress(this.data)
  }
}
</script>
<style scoped>
#performanceScore {
  text-align: center;
}

</style>
